<template>
  <div style="width:100%;">
    <el-select
      v-model="groupId"
      style="vertical-align: top;width:100%"
      placeholder="请选择分组"
      clearable
      @change="handleChange">
      <el-option
        v-for="item in list"
        :key="item.groupId"
        :label="item.groupName"
        :value="item.groupId">
      </el-option>
      <div
        v-if="showAdd"
        slot="empty">
        <p class="el-select-dropdown__empty">无数据</p>
        <el-button
          style="width:100%;"
          @click="add">添加分组</el-button>
      </div>
      <el-button
        v-if="showAdd"
        type="primary"
        style="width:100%;margin-top: 10px"
        @click="add">添加分组</el-button>
    </el-select>
    <product-group-modal
      ref="group"
      :callback="cb" />
  </div>
</template>

<script>
import ProductGroupModal from '../../page/wxapp-set/busi/product-group-modal.vue'
export default {
  name: 'ProductGroupSelect',
  components: { ProductGroupModal },
  props: {
    showAdd: { type: Boolean, default: true },
    value: {
      required: true
    },
    callback: {
      type: Function
    },
    option: {
      type: Object
    }
  },
  data() {
    return {
      list: []
    }
  },
  computed: {
    groupId: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    handleChange() {
      this.callback && this.callback()
    },
    cb() {
      this.fetchList()
    },
    add() {
      this.$refs.group.getsetting()
    },
    fetchList() {
      this.$store.dispatch('productgroup/getgroups', {
        payload: {
          ...this.option,
          pageNum: 1,
          groupId: 0,
          pageSize: 100
        },
        success: (res) => {
          this.list = res.data.records
          if (this.list.findIndex(i => i.groupId === this.groupId) === -1) {
            this.groupId = null
          }
        },
        fail: () => {
          this.list = []
        }
      })
    }
  }
}
</script>
